{
  "title": "Modifier l'équipe",
  "nameLabel": "Nom de l'équipe",
  "save": "Enregistrer",
  "saving": "Enregistrement…"
}
